module.exports = __webpack_public_path__ + "0ccc023a04ae34292cdb3b6b54cd7c88.png";